<h1 translate>Contents</h1>
<div class="workshop-list">
    <ng-container *ngFor="let workshop of getWorkshops()">
        <button mat-menu-item class="{{workshop.id == model.workshop_id?'current':''}}" (click)="select(workshop);">{{workshop.title}}</button>
    </ng-container>
</div>
